import {useQuery} from 'react-query';
import {client} from './ApiClient';
import {mapServiceUrls} from '../Helpers/Functions';

const getWalletCouponsByEngagement = (key: any, urls: any, domain: string, deviceCode: string, engagementToken: string) => {
	return client(urls.LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/snippets/engagements/${engagementToken}`);
}

export default function useWalletCoupons(urls: any, domain: string, deviceCode: string, engagementToken?: string) {
	const { status, data, error, isFetching, refetch } = useQuery(
		['WalletCoupons', engagementToken],
		(key) => getWalletCouponsByEngagement(key, mapServiceUrls(urls), domain, deviceCode, engagementToken as string),
		{ enabled: urls && !!engagementToken, staleTime: 1000*60*5 }
	);

	const walletCouponsStatus = status;
	// API client standard shape: { status: 'success', data: <payload> }
	const walletCoupons = data ? data.data : undefined;
	const walletCouponsError = error;
	const isWalletCouponsFetching = isFetching;

	return { walletCouponsStatus, walletCoupons, walletCouponsError, isWalletCouponsFetching, refetch };
}


